export default __webpack_public_path__ + "static/media/left_arror.5bb2d277.svg";